
import { UserPublicProfile } from "@/common-datatypes";
import Common from "@/mixins/common";
import { auth } from "@/scripts/firebase"
import { UserInfo } from "@firebase/auth";
//import { is } from 'vee-validate/dist/rules';
//import { maritoUser } from "@/scripts/datatypes";
import { Component,Watch} from "vue-property-decorator";

@Component

/**
 * router-link-exact-active 要素に is-active 加える
 * 上記の要素の親 .navbar-dropdown は none にしない
 * もうすこし色々工夫する
 */

export default class Header extends Common {
  isActive = [false,false,false,false,false,false,false,false,false]

  inActive(exclude = -1){
    this.isActive.forEach((isActive: boolean,index: number) =>{
      if(isActive && exclude !== index){
        this.$set(this.isActive,index,false)
      }
    })
  }

  async created(){
    //window.addEventListener('scroll', this.inActive)
    window.addEventListener('resize', () =>{this.inActive()})

    document.addEventListener('click', (event) => {
      const target = event.target as HTMLElement
      if(! target.closest('nav.navbar')){
        this.inActive()
      }
    },false)

  }

  get signedUp(): boolean {
    return this.$store.getters.signedUp
  }

  get invited(): boolean {
    return this.$store.getters.invited
  }

  get noSchool(): boolean {
    return this.$store.getters.noSchool
  }

  get signIn(): boolean {
    return !! this.$store.getters.uid
  }

  get isOwner(): boolean {
    return Array.isArray(this.$store.getters.roles) && this.$store.getters.roles.includes('owner') && this.$store.getters.disabled === false
  }

  get isAdmin(): boolean {
    return Array.isArray(this.$store.getters.roles) && this.$store.getters.roles.includes('admin') && this.$store.getters.disabled === false
  }

  get isStaff(): boolean {
    return Array.isArray(this.$store.getters.roles) && ['owner','admin','staff'].some((role) => { return this.$store.getters.roles.includes(role)}) && this.$store.getters.disabled === false
  }

  get schoolName(): string {
    return (this.$store.getters.schoolName || '')
  }

  get displayName(){
    const user = this.$store.state.user as UserInfo
    const userPublicProfile = this.$store.state.userPublicProfile as UserPublicProfile
    if(userPublicProfile){
      return this.$t('text.name',{firstName: userPublicProfile.firstName, lastName: userPublicProfile.lastName}) || ''
    }
    
    if(user){
      return user.displayName || ''
    }

    return ''
  }

  get uid(): string {
    return (this.$store.getters.uid || '')
  }

  @Watch('routePath') setStatus(){
    this.inActive()
  }

  get routePath(): string {
    return this.$route.path
  }

  toggleActive(target: number, event: Event){
    console.log(event)
    if(this.isActive[target]){
      this.$set(this.isActive,target,false)
    }else{
      this.inActive(0)
      this.$set(this.isActive,target,true)
    }
  }
   
  handleSignOut() {
    auth.signOut();
    this.inActive()
  }
}
